import {
  generateQueryString,
  requestVehicleSearchCount,
} from '@lib/requests/vehicleSearchCount';
import { devConsoleError } from '@lib/logger';

import {
  ResponseData,
  SnakeCasedMakeFilters,
} from '@javascript/types/SeoPageTypes';

const seoMakePage = (): void => {
  const makeInput = document.getElementById('make') as HTMLInputElement;
  const modelSelect = document.getElementById('models') as HTMLSelectElement;
  const searchCta = document.getElementById('search-cta') as HTMLButtonElement;

  const getMakeCount = async (): Promise<ResponseData> => {
    const filters: SnakeCasedMakeFilters = {
      count_only: true,
      make: makeInput.value,
      model: modelSelect.value,
      sort_order: 'price_up',
      unreserved_only: true,
    };

    const queryString = generateQueryString(filters);
    const response = await requestVehicleSearchCount(queryString);

    if (!response || typeof response.count !== 'number') {
      throw new Error('Invalid API response: Expected { count: number }');
    }

    return response;
  };

  const updateCta = async (): Promise<void> => {
    searchCta.classList.add('ch-btn--loading');

    try {
      const { count } = await getMakeCount();
      searchCta.textContent = `Search ${count} ${count === 1 ? 'car' : 'cars'}`;
    } catch (error) {
      devConsoleError(error);
      searchCta.textContent = 'Search our cars';
    }
    searchCta.classList.remove('ch-btn--loading');
  };

  modelSelect.addEventListener('change', updateCta);
};

export default seoMakePage;

document.addEventListener('DOMContentLoaded', (): void => {
  seoMakePage();
});
